import { createSlice } from '@reduxjs/toolkit';

// ================== Reducers ================== //

const slice = createSlice({
  name: 'nomad_insurance/purchaseInsurance/destinations',
  initialState: {
    destinations: [],
    isValid: false
  },
  reducers: {
    setDestinations: (state, { payload }) => {
      state.destinations = payload;
    },
    setValidity: (state, { payload }) => {
      state.isValid = payload;
    }
  }
});

export default slice.reducer;

// ================== Actions ================== //

const { actions } = slice;

export const setDestinations = (destinations) => (dispatch) => {
  dispatch(actions.setDestinations(destinations));
};

export const setValidity = (isValid) => (dispatch) => {
  dispatch(actions.setValidity(isValid));
};
